import { render, staticRenderFns } from "./InsuredObjects.vue?vue&type=template&id=a6e3cb08"
import script from "./InsuredObjects.vue?vue&type=script&lang=js"
export * from "./InsuredObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports